import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Call } from '@gem/call/CallStore/Call';
import { CallState } from '@gem/call/CallView/Shared/CallState/CallState';

import styles from './CallingPlaceholder.styles.m.css';

interface ICallingPlaceholderProps {
  call: Call;
}

export const CallingPlaceholder: FC<ICallingPlaceholderProps> = observer(({ call }) => {
  if (!call) {
    return null;
  }

  return (
    <div className={styles.callingPlaceholderContainer}>
      <div className={styles.groupTitle}>{call.avatar.title}</div>
      <div className={styles.callingState}>
        <CallState call={call} />
      </div>
    </div>
  );
});
